import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	accoListContainer: {
		marginTop: theme.spacing.small,
		marginBottom: theme.spacing.xxlarge,

		[getFromBreakpoint('lg')]: {
			marginTop: theme.spacing.medium,
		},
	},
	accoTile: {
		marginBottom: theme.spacing.medium,
	},
	totalLabel: {
		fontSize: theme.fontSize.xxSmall,
		color: '#949494', // no such color in new theme
		marginBottom: theme.spacing.small,
	},
}));
